import { render, staticRenderFns } from "./itemUpload.vue?vue&type=template&id=18075fc8&scoped=true&"
import script from "./itemUpload.vue?vue&type=script&lang=js&"
export * from "./itemUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18075fc8",
  null
  
)

export default component.exports